import React from "react";
import PropTypes from "prop-types";
import { autobind } from "lib/decorators";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../themes/theme";

@autobind
class Movable extends React.Component {
  static childContextTypes = {
    movable: PropTypes.object,
  };

  getChildContext() {
    return { movable: this };
  }

  componentWillMount() {
    this.setState({ x: 0, y: 0 });
  }

  onStartDrag(evt) {
    this.setState({
      startClientX: evt.clientX,
      startClientY: evt.clientY,
      startX: this.state.x,
      startY: this.state.y,
    });
    document.body.addEventListener("mousemove", this.onMouseMove);
    document.body.addEventListener("mouseup", this.onMouseUp);
  }

  onMouseUp() {
    document.body.removeEventListener("mousemove", this.onMouseMove);
    document.body.removeEventListener("mouseup", this.onMouseUp);
  }

  onMouseMove(evt) {
    if (evt.buttons === 0) {
      this.onMouseUp();
    } else {
      this.setState({
        x: this.state.startX + (evt.clientX - this.state.startClientX),
        y: this.state.startY + (evt.clientY - this.state.startClientY),
      });
    }
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        {this.props.enabled ? (
          <span
            className="movablemodal-movable"
            style={{
              position: "relative",
              top: this.state.y,
              left: this.state.x,
            }}
          >
            {this.props.children}
          </span>
        ) : (
          <span>{this.props.children}</span>
        )}
      </ThemeProvider>
    );
  }
}

@autobind
class MovableGrip extends React.Component {
  static contextTypes = {
    movable: PropTypes.object,
  };

  onMouseDown(evt) {
    if (this.props.onMouseDown) {
      this.props.onMouseDown(evt);
    }
    evt.preventDefault();
    let movable = this.context.movable;
    if (movable) {
      movable.onStartDrag(evt);
    }
  }

  render() {
    if (
      this.props.enabled === false ||
      !this.context ||
      !this.context.movable
    ) {
      return <span children={this.props.children} />;
    }
    return (
      <span
        className="movablemodal-movable-grip"
        children={this.props.children}
        onMouseDown={this.onMouseDown}
      />
    );
  }
}

export { Movable, MovableGrip };
